export default __webpack_public_path__ + "static/media/mode-71.41f76488.svg";